import { React } from 'react';
import { Grid } from '@material-ui/core';

const StyleButton = ({ style, label, active, onToggle, icon = false }) => {
    const toggle = e => {
        e.preventDefault();
        onToggle(style);
    };

    return (
        <Grid
            item
            className={active ? 'richEditorActiveButton' : 'richEditorStyleButton'}
            onMouseDown={toggle}
        >
            {icon ? <i className={`fa-solid fa-${icon}`} title={label} /> : label}
        </Grid>
    );
};

export default StyleButton;
